import React from 'react';
import resume from '../data/resume';

const Certificates = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const certificateStyle = {
    marginBottom: '15px',
    padding: '10px',
    border: '1px solid #00FF00',
    backgroundColor: '#001100',
    marginLeft: 'clamp(12px, 4vw, 30px)'
  };

  const certTitleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0 0 5px 0',
    letterSpacing: '1px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const issuerStyle = {
    fontSize: '14px',
    margin: '0 0 5px 0',
    opacity: 0.9,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const descriptionStyle = {
    fontSize: '13px',
    margin: '0',
    lineHeight: '1.4',
    opacity: 0.8,
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const certificates = resume.certificates;

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ cat certificates.txt</div>
      <h2 style={headingStyle}>[ CERTIFICATES ]</h2>
      {certificates.map((cert, index) => (
        <div key={index} style={certificateStyle}>
          <h3 style={certTitleStyle}>┌─ {cert.title}</h3>
          <p style={issuerStyle}>│ Issuer: {cert.issuer}</p>
          <p style={descriptionStyle}>└─ {cert.description}</p>
        </div>
      ))}
    </section>
  );
};

export default Certificates;
